import React from 'react';
import Fetch from './Fetch';

class Greeter extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Fetch
        url="//booksearch.delbanco.de/life/loginapi.php"
        data={{
          dataset: 'profile'
        }}
      >
        {({ data }) =>
          data && (
            <div className="greeter">
              Welcome,{' '}
              <span className="greeter-name">
                {data[0].firstname} {data[0].lastname}
              </span>!
            </div>
          )}
      </Fetch>
    );
  }
}

Greeter.propTypes = {
  name: React.PropTypes.string
};

Greeter.defaultProps = {
  name: 'Anonymous'
};

export default Greeter;



// WEBPACK FOOTER //
// ./src/js/components/Greeter.js